import {testTokenScope} from "^/IxPlugin/api"

export function showAddToCart() {
  return testTokenScope('cart.write', 'lineitem.write')
}

export function showPricing() {
  return testTokenScope('price.read')
}


// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/utils/scopeHelpers.js